package com.schoolconnect.app.feature.splash

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Surface
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp

internal val SplashTop = Color(0xFF06123E)
internal val SplashMid = Color(0xFF0B4BD8)
internal val SplashAccent = Color(0xFF53C2FF)
internal val SplashSoft = Color(0xFFEAF6FF)

@Composable
internal fun SplashGlow(
    modifier: Modifier,
    tint: Color
) {
    Box(
        modifier = modifier
            .clip(CircleShape)
            .background(
                Brush.radialGradient(
                    colors = listOf(tint, Color.Transparent)
                )
            )
    )
}

@Composable
internal fun SplashTrustChip(text: String) {
    Surface(
        shape = RoundedCornerShape(999.dp),
        color = Color.White.copy(alpha = 0.10f),
        tonalElevation = 0.dp
    ) {
        Text(
            text = text,
            modifier = Modifier.padding(horizontal = 14.dp, vertical = 8.dp),
            color = Color.White.copy(alpha = 0.88f),
            style = MaterialTheme.typography.labelMedium
        )
    }
}
